import {
  getCertificateStatus,
  applyCertificate,
  getUserApplications,
  getAllApplications,
  approveApplication,
} from "./asyncThunks";

export const getCertificateStatusBuilder = (builder) => {
  builder
    .addCase(getCertificateStatus.pending, (state) => {
      state.statusLoading = true;
      state.error = null;
    })
    .addCase(getCertificateStatus.fulfilled, (state, action) => {
      state.statusLoading = false;
      state.certificateStatus = action.payload;
    })
    .addCase(getCertificateStatus.rejected, (state, action) => {
      state.statusLoading = false;
      state.error = action.error.message;
    });
};

export const applyCertificateBuilder = (builder) => {
  builder
    .addCase(applyCertificate.pending, (state) => {
      state.applicationLoading = true;
      state.error = null;
    })
    .addCase(applyCertificate.fulfilled, (state, action) => {
      state.applicationLoading = false;
      // Backend returns the application object, we need to format it for certificate status
      const application = action.payload.application || action.payload;
      state.certificateStatus = {
        success: true,
        hasApplication: true,
        status: application.status || 'pending',
        application: application
      };
    })
    .addCase(applyCertificate.rejected, (state, action) => {
      state.applicationLoading = false;
      state.error = action.error.message;
    });
};

export const getUserApplicationsBuilder = (builder) => {
  builder
    .addCase(getUserApplications.pending, (state) => {
      state.applicationsLoading = true;
      state.error = null;
    })
    .addCase(getUserApplications.fulfilled, (state, action) => {
      state.applicationsLoading = false;
      state.userApplications = Array.isArray(action.payload?.applications)
        ? action.payload.applications
        : Array.isArray(action.payload)
          ? action.payload
          : [];
    })
    .addCase(getUserApplications.rejected, (state, action) => {
      state.applicationsLoading = false;
      state.error = action.error.message;
    });
};

// Admin builders
export const getAllApplicationsBuilder = (builder) => {
  builder
    .addCase(getAllApplications.pending, (state) => {
      state.allApplicationsLoading = true;
      state.error = null;
    })
    .addCase(getAllApplications.fulfilled, (state, action) => {
      state.allApplicationsLoading = false;
      const apps = action.payload.applications || action.payload;
      state.allApplications = apps.map((app) => ({
        ...app,
        workImages: typeof app.workImages === "string" ? JSON.parse(app.workImages) : app.workImages,
      }));
    })
    .addCase(getAllApplications.rejected, (state, action) => {
      state.allApplicationsLoading = false;
      state.error = action.error.message;
    });
};

export const approveApplicationBuilder = (builder) => {
  builder
    .addCase(approveApplication.pending, (state) => {
      state.reviewLoading = true;
      state.error = null;
    })
    .addCase(approveApplication.fulfilled, (state, action) => {
      state.reviewLoading = false;
      const { applicationId, response } = action.payload;
      
      // Update the specific application in allApplications array
      const applicationIndex = state.allApplications.findIndex(
        (app) => app.id === applicationId
      );
      
      if (applicationIndex !== -1) {
        state.allApplications[applicationIndex] = {
          ...state.allApplications[applicationIndex],
          status: 'approved',
          certificateUrl: response.application?.certificateUrl,
          reviewedAt: new Date().toISOString(),
        };
      }
    })
    .addCase(approveApplication.rejected, (state, action) => {
      state.reviewLoading = false;
      state.error = action.error.message;
    });
};